"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECustomerImportAPI = exports.ESalutation = exports.ECustomerType = void 0;
var ECustomerType;
(function (ECustomerType) {
    ECustomerType["PRIVATE"] = "P";
    ECustomerType["COMMERCIAL"] = "C";
})(ECustomerType = exports.ECustomerType || (exports.ECustomerType = {}));
var ESalutation;
(function (ESalutation) {
    ESalutation["MALE"] = "M";
    ESalutation["FEMALE"] = "F";
    ESalutation["OTHER"] = "O";
})(ESalutation = exports.ESalutation || (exports.ESalutation = {}));
var ECustomerImportAPI;
(function (ECustomerImportAPI) {
    ECustomerImportAPI["LAX"] = "LAX";
    ECustomerImportAPI["LOCOSOFT"] = "LOCOSOFT";
})(ECustomerImportAPI = exports.ECustomerImportAPI || (exports.ECustomerImportAPI = {}));
